import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useSubmit,
    useSearchParams
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.rule_id;
    const searchParams = new URL(request.url).searchParams;
    const age_payment_id = searchParams.get("id");
    const form = (await api.get(`api/age_payment/child/${age_payment_id}/0/`)).data.form;
    return {form};
}

export async function action({request, params}) {
    const formData = await request.formData();
    const obj_id = params.object_id;
    const age_payment_id = formData.get("children_tarrifs_id");
    try {
        const response = await api.patch(`api/age_payment/child/${age_payment_id}/0/`, formData);

        if (response.status === 200) {
            showSnackbar("Дитячий тариф успішно оновлено!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/children_tarrifs`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при оновлені дитячого тарифу', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {

        console.log("PATCH error:", e);

        const backendDetail =
            e.response?.data?.detail ||
            e.response?.data?.message ||
            null;

        const conflicts =
            Array.isArray(e.response?.data?.conflicts)
                ? ` Конфліктуючі діапазони: ${e.response.data.conflicts.join(", ")}`
                : "";

        const message =
            backendDetail
                ? backendDetail + conflicts
                : "Сталася невідома помилка при оновленні тарифу";

        showSnackbar(message, "error", {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });

        return null;
    }
    return null;
}

export default function ObjectChildrenTarrifsEdit() {
    const {object_id, rule_id} = useParams();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const children_tarrifs_id = searchParams.get("id");
    const actionData = useActionData();

    const revalidator = useRevalidator();
    const {form, data} = useLoaderData();
    const formHook = useForm();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, children_tarrifs_id: children_tarrifs_id});
        submit(formData, {
            method: 'post'
        })
    }

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/children_tarrifs_id`}
            title={{text: 'Змінити дитячий тариф'}}
        >
            <PageTitle title={`Редагування дитячого тарифу: ${children_tarrifs_id || rule_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={form}
                formName='HotelAgePaymentForm'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
